import _ from "lodash";
export function getPrecisions(values, propertyName) {
	return _.map(values, (v) => {
		v[propertyName] = getPrecision(v[propertyName]);
		return v;
	});
}

export function getPrecision(value) {
	if (value) {
		const calculatedPrecisionValue = calculatePrecision(value, false);
		return calculatedPrecisionValue;
	}

	return value;
}

export function getPrecisionString(value) {
	if (value) {
		const calculatedPrecisionValue = calculatePrecision(value, true);
		return calculatedPrecisionValue;
	}

	return value;
}

function calculatePrecision(value, asString) {
	if (Number(value) >= 1000) {
		value = Number(value).toFixed(0);
	} else if (Number(value) < 1000 && Number(value) > 1) {
		value = Number(value).toFixed(2);
	} else {
		value = Number(value).toFixed(5);
	}
	return asString ? value : Number(value);
}
